export const getRatingStar = (rating) => {
  const temp = Math.round(rating);
  if (temp === 5) {
    return (
      <>
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
      </>
    );
  } else if (temp === 4) {
    return (
      <>
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
      </>
    );
  } else if (temp === 3) {
    return (
      <>
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
      </>
    );
  } else if (temp === 2) {
    return (
      <>
        <img src="./images/customerRationgImg.svg" alt="" />
        <img src="./images/customerRationgImg.svg" alt="" />
      </>
    );
  } else if (temp === 1) {
    return (
      <>
        <img src="./images/customerRationgImg.svg" alt="" />
      </>
    );
  } else {
    return <></>;
  }
};
